import { NationalIdentificationNumberCountry } from '@dreryk/personal-external-identifier-common-api';

import { commonTranslationKeys, createTranslatedText, FormContextValues, getCurrentLocale } from '@dreryk/react-common';
import { Select, StyledMaxWidth, useSelectContext } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../../../translations';
import {
   createNationalIdentificationNumberCountryFilter,
   nationalIdentificationNumberCountryIsoCodeGetter,
} from '../../../common.utils';

type PartialFormBean = {
   nationalIdentificationNumberCountry?: NationalIdentificationNumberCountry | null;
};

export type NationalIdentificationNumberCountryFieldProps = Pick<FormContextValues<PartialFormBean>, 'register'>;

const getCountryLabel = (item?: NationalIdentificationNumberCountry): string =>
   item ? item.getValue().getName(getCurrentLocale()) : '';

const nationalIdentificationNumberCountries = NationalIdentificationNumberCountry.searchAll(getCurrentLocale());
const CountriesList = (): JSX.Element => {
   const { searchText } = useSelectContext();
   const filteredCountries = nationalIdentificationNumberCountries.filter(
      createNationalIdentificationNumberCountryFilter(searchText)
   );
   if (!filteredCountries.length) {
      return <Select.NoItems testId={'noCountries'} />;
   }
   return (
      <Select.List<NationalIdentificationNumberCountry>
         items={filteredCountries}
         keyExtractor={nationalIdentificationNumberCountryIsoCodeGetter}
      >
         {(country: NationalIdentificationNumberCountry) => (
            <Select.Item<NationalIdentificationNumberCountry>
               item={country}
               testId={nationalIdentificationNumberCountryIsoCodeGetter(country)}
               label={<Select.Highlight node={createTranslatedText(getCountryLabel(country))} />}
            />
         )}
      </Select.List>
   );
};

export const NationalIdentificationNumberCountryField = (
   props: NationalIdentificationNumberCountryFieldProps
): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={308}>
         <Select<NationalIdentificationNumberCountry>
            testId={'nationalIdentificationNumberCountry'}
            triggerLabelExtractor={getCountryLabel}
            controller={props.register('nationalIdentificationNumberCountry', { required: true })}
            label={patientTranslationKeys.sendingCountry}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
            defaultValue={null}
         >
            <CountriesList />
         </Select>
      </StyledMaxWidth>
   );
};
